var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "screen" }, [
    _c("div", { staticClass: "screen__inner--last" }, [
      _c("div", { staticClass: "screen__line" }, [
        _c("img", { attrs: { src: _vm.quizBlueLine, alt: "" } }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "screen__img" }, [
        _c("img", { attrs: { src: _vm.greenCheckMark, alt: "" } }),
      ]),
      _vm._v(" "),
      _c("h3", { staticClass: "screen__title heading-tertiary" }, [
        _vm._v(_vm._s(_vm.$t("__quiz_screen_7_title"))),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "screen__button screen__button--center btn btn-primary",
        on: { click: _vm.handleRestart },
      },
      [
        _vm._v(
          "\n        " + _vm._s(_vm.$t("__quiz_screen_7_start_over")) + "\n    "
        ),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "screen__background" }, [
      _c("img", { attrs: { src: _vm.questionIcon, alt: "" } }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }